/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { unitSchema } from "../unitSchema.ts";
import { z } from "zod";

export const deleteApiTracksQueryParamsSchema = z.object({
    "TrackIds": z.array(z.string().uuid()).describe("Идентификаторы треков").optional(),
"AuthorId": z.string().uuid().describe("Удалить все треки автора").optional(),
"AlbumId": z.string().uuid().describe("Удалить все треки из альбома").optional()
    }).optional()

/**
 * @description Трек удален
 */
export const deleteApiTracks200Schema = z.lazy(() => unitSchema)

/**
 * @description Ошибка валидации запроса | Неправильный запрос
 */
export const deleteApiTracks400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const deleteApiTracks401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const deleteApiTracks403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Not Found
 */
export const deleteApiTracks404Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const deleteApiTracks500Schema = z.lazy(() => badResponseModelSchema)

export const deleteApiTracksMutationResponseSchema = z.lazy(() => deleteApiTracks200Schema)